export function getProductBrand(product = {}) {
  const specs =
    product?.specs && typeof product.specs === 'object' && !Array.isArray(product.specs) ? product.specs : {};
  return String(specs.brand || specs.manufacturer || specs.make || '').trim();
}

export function getProductBrandOptions(products = [], currentBrand = '') {
  const brands = new Set();

  (Array.isArray(products) ? products : []).forEach((product) => {
    const brand =
      getProductBrand(product) ||
      String(product?.name || product?.label || product?.brand || product?.slug || '').trim();
    if (brand) brands.add(brand);
  });

  const selectedBrand = String(currentBrand || '').trim();
  if (selectedBrand) brands.add(selectedBrand);

  return [...brands].sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base' }));
}
